import Video from '@models/videos/video.model';
import { ModelMixin } from '@models/core/base-generic.model';
import { Employee } from '@models/employee/employee.model';

export class OnboardingVideo extends ModelMixin<OnboardingVideo>() {
    protected static _type = 'onboardingVideos';
    protected static _resource = 'companyManagement/onboardingVideos';
    protected static _version = 'v2';

    protected static _serializeAttributes = ['employeeId', 'videoId'];

    get videoId(): number {
        return this._attributes['videoId'];
    }

    set videoId(id: number) {
        this._attributes['videoId'] = id;
    }

    get employeeId(): number {
        return this._attributes['employeeId'];
    }

    set employeeId(id: number) {
        this._attributes['employeeId'] = id;
    }

    get video(): Video {
        return this.hasOne(Video, 'video');
    }

    set video(video: Video) {
        this._attributes['videoId'] = video?.id;
        this.setOne('video', video);
    }

    get employee(): Employee {
        return this.hasOne(Employee, 'employee');
    }

    set employee(employee: Employee) {
        this._attributes['employeeId'] = employee?.id;
        this.setOne('employee', employee);
    }
}
